import { render, staticRenderFns } from "./BarChartOrderCount.vue?vue&type=template&id=1f770b69&"
import script from "./BarChartOrderCount.vue?vue&type=script&lang=js&"
export * from "./BarChartOrderCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports